import React, { useEffect, useState } from 'react';
import CheckboxOn from "../../assets/images/CheckboxOn.svg";
import CheckboxOff from "../../assets/images/CheckboxOff.svg";

function IndividualRecipient(props) {

    let { val, selectedRelative } = props

    const [checked, setChecked] = useState(false)

    let handleRadio = (e, uuid, val) => {

        setChecked(e.target.checked)
        props.handleRadio(uuid, val);
    }

    useEffect(() => {
        if (selectedRelative && JSON.stringify(selectedRelative).includes(val.uuid)) {
            setChecked(true)
        } else {
            setChecked(false)
        }
    }, [selectedRelative])

    return (
        <>
            <div className="relative-cont-out">
                <div
                    className="relative-check"
                >
                    <input type="checkbox" name='compareProduct' onChange={(e) => {
                        e.stopPropagation();
                        handleRadio(e, val.uuid, val);
                    }}
                        value={val} checked={checked}
                    />
                </div>
                <div className="title-text" style={{ marginLeft: '12px' }}>{val.full_name}</div>
            </div>
        </>
    )
}

export default IndividualRecipient
